// import Seo from '@/components/Seo/Seo'
import { Box, Tab, Tabs } from "@mui/material";
import styles from "../../../../styles/pages/user/pending-titling.module.scss";
import React from "react";
import UserTitlingIcon from "../../../../ui/Icons/UserTitlingIcon";
import UserRevisionIcon from "../../../../ui/Icons/UserRevisionIcon";
import UserCopyWriterWrapper from "../../../../layout/userwrapper/UserCopyWriterWrapper";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import CopywriterPendingTitlingVideoPage from "../../../../components/CopywriterPendingVideoPage/CopywriterPendingTitlingVideoPage";

const PendingTitling = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  /***************feedbackModal****************/

  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClickClose = () => {
    setOpen(false);
  };
  const handleClose = (value) => {
    setOpen(false);
  };

  /****************feedbackModal***************/

  return (
    // <UserCopyWriterWrapper headerPurchaseBtn={false} footerChatBtn={true}>
    //     <Seo title="Pending Titling" canonical={''} description={''} url={''} image={''} />

    //     <Box className="main_body">
    //         <Box className={styles.copywriterWrapper}>
    //             <Box className={styles.copywriterTab}>
    //                 <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
    //                     <Tab label=
    //                         {<>
    //                             <Box className={styles.tabItem}>
    //                                 <Box className={styles.tabitemImg}>
    //                                     <UserTitlingIcon />
    //                                 </Box>

    //                                 <p>Pending Titling <span>23456</span></p>
    //                             </Box>
    //                         </>}
    //                         {...a11yProps(0)} />
    //                     <Tab label=
    //                         {<>
    //                             <Box className={styles.tabItem}>
    //                                 <Box className={styles.tabitemImg}>
    //                                     <UserRevisionIcon />
    //                                 </Box>

    //                                 <p>Pending Revision <span>150</span></p>
    //                             </Box>
    //                         </>}
    //                         {...a11yProps(1)} />
    //                 </Tabs>
    //             </Box>

    //             <Box className={styles.copywriterPendingTitlingBody}>
    //                 <PerfectScrollbar>
    //                     <CustomTabPanel value={value} index={0}>
    //                         <CopywritePendingTitlingTable/>
    //                     </CustomTabPanel>
    //                     <CustomTabPanel value={value} index={1}>
    //                         dfgdgfdg
    //                     </CustomTabPanel>
    //                 </PerfectScrollbar>
    //             </Box>
    //         </Box>
    //     </Box>
    // </UserCopyWriterWrapper>

    <>
      <CopywriterPendingTitlingVideoPage />
    </>
  );
};

export default PendingTitling;
